import type { FireflyRuntime, ModuleRegisterFunction } from "@squide/firefly";

export const registerReviews: ModuleRegisterFunction<FireflyRuntime> = async runtime => {
    if (runtime.isMswEnabled) {
        const [{ filterOptionsRequestHandler }, { reviewExportRequestHandler }, { reviewsRequestHandler }, { cycleExportsRequestHandlers }, { reviewCyclesRequestHandler }] = await Promise.all([
            import("./mocks/reviewee-filters/filterOptionsRequestHandler.ts"),
            import("./mocks/reviews/reviewExportRequestHandler.ts"),
            import("./mocks/reviews/reviewsRequestHandler.ts"),
            import("./mocks/cycles/cycleExportsRequestHandler.ts"),
            import("./mocks/cycles/reviewCyclesRequestHandler.ts")
        ]);

        runtime.registerRequestHandlers([filterOptionsRequestHandler, reviewExportRequestHandler, reviewsRequestHandler, ...cycleExportsRequestHandlers, reviewCyclesRequestHandler]);
    }
};
